import { Section, Eyebrow, ChromeHeading } from "../funnel";

export const HearIt = () => (
  <Section data-testid="hear-it-section">
    <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
      <div>
        <Eyebrow>HEAR IT FROM THEM</Eyebrow>
        <ChromeHeading className="mt-4 text-4xl sm:text-5xl lg:text-6xl">A business owner on working with J11</ChromeHeading>
        <p className="mt-6 text-[16px] leading-relaxed text-[#cfc7b6]">Don't take my word for it. Hear what it's like to work with our team, in a client's own words.</p>
        <p className="mt-4 text-[12px] text-[#8a857b]">Individual client experience. Results vary and are not typical or guaranteed.</p>
      </div>
      <figure className="mx-auto w-full max-w-[340px] pr-3">
        <video src="/assets/testimonial-push.mp4" poster="/assets/testimonial-push-poster.jpg" controls playsInline preload="none" className="gold-frame block aspect-[9/16] w-full rounded-sm bg-black object-cover" data-testid="testimonial-video" aria-label="Business owner · J11 client" />
        <figcaption className="font-mono-plex mt-6 text-[11px] uppercase tracking-[0.16em] text-[#a59f93]">Business owner · J11 client</figcaption>
      </figure>
    </div>
  </Section>
);
